import * as CryptoJS from 'crypto-js'

const getHashedValue = (stringToHash: string): string => {
  const hash = CryptoJS.SHA256(stringToHash)
  return hash.toString(CryptoJS.enc.Hex)
}

export const cryptoService = {
  getHashedValue,
}
